import { render, staticRenderFns } from "./MemberServices.vue?vue&type=template&id=23d7ef16&"
import script from "./MemberServices.vue?vue&type=script&lang=js&"
export * from "./MemberServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports